/**
 * Updates document head tags for SEO and social sharing on SPA route changes.
 */

function setMetaName(name: string, content: string): void {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function setMetaProperty(property: string, content: string): void {
  let meta = document.querySelector(`meta[property="${property}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('property', property);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function setCanonicalUrl(url: string): void {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = url;
}

/** Apply title, description, canonical, Open Graph, and Twitter tags for the current page. */
export function applyPageHeadMeta(
  title: string,
  description: string,
  pathname: string,
  robots?: string | null,
  canonicalPath?: string | null,
): void {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const normalizedPath = pathname === '/' ? '' : pathname.replace(/\/$/, '');
  const pageUrl = `${origin}${normalizedPath || '/'}`;
  const canonicalUrl =
    canonicalPath !== undefined && canonicalPath !== null
      ? `${origin}${canonicalPath === '/' ? '' : canonicalPath.replace(/\/$/, '')}`
      : pageUrl;

  document.title = title;
  setMetaName('description', description);
  setCanonicalUrl(canonicalUrl);

  if (robots) {
    setMetaName('robots', robots);
  } else {
    document.querySelector('meta[name="robots"]')?.remove();
  }

  setMetaProperty('og:url', canonicalUrl);
  setMetaProperty('og:title', title);
  setMetaProperty('og:description', description);

  setMetaName('twitter:url', canonicalUrl);
  setMetaName('twitter:title', title);
  setMetaName('twitter:description', description);
}
